import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { Card as oCard, CardHeader as oCardHeader } from 'components/Cards/DataCardHotels/styles';

export const Card = styled(oCard)`
  height: 242px;
`;

export const CardHeader = styled(oCardHeader)`
  display: block;
  min-height: calc(100% / 2);
  background: rgb(${ColorPalette.RGB.AntiFlashWhite3});
  border: none;
  &::before {
    background-image: none;
  }
`;
